import { SearchForm } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { changedMeetingFilters, useIsMyCalendlyScope } from 'components/meetings/filter_modal/utils';
import { useFetchMeetingsFilterCountForAnalytics } from 'features/meetings/hooks/use_results_count';
import { mapChangedFiltersForAnalytics } from 'features/meetings/utils';
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events';
import { isMeetingsTabPathPrefix } from 'hooks/home/tabs';
import { useFilters } from 'hooks/meetings/filters';
const containerCss = "c1rgyggd";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const Search = ({
  initialValue = '',
  filterDefaults = {}
}) => {
  const history = useHistory();
  const track = useTrack();
  const isPhone = useDeviceType('isPhone');
  const {
    getFilterParams
  } = useFilters();
  const filterParams = getFilterParams(filterDefaults);
  const isMyCalendlyScope = useIsMyCalendlyScope();
  const fetchResultsCountForAnalytics = useFetchMeetingsFilterCountForAnalytics(filterDefaults);
  const sendAnalytics = useCallback((searchQuery, resultsCount) => {
    const paramsForAnalytics = {
      ...filterParams,
      search_keyword: searchQuery
    };
    const isMeetingsPage = isMeetingsTabPathPrefix(history.location.pathname);
    const changedFilters = changedMeetingFilters(isMeetingsPage, isMyCalendlyScope, paramsForAnalytics);
    const properties = {
      results_count: resultsCount,
      search_type: 'text',
      location: 'meetings_page',
      filters: mapChangedFiltersForAnalytics(changedFilters),
      search_text: searchQuery
    };
    track({
      name: TRACKING_EVENT_NAMES.SEARCH_PERFORMED,
      properties
    });
  }, [filterParams, history.location.pathname, isMyCalendlyScope, track]);
  const updateSearchParam = value => {
    const params = new URLSearchParams(history.location.search);
    if (value) {
      params.set('search_keyword', value);
    } else {
      params.delete('search_keyword');
    }
    history.replace({
      ...history.location,
      search: params.toString()
    });
  };
  const handleSubmit = async searchQuery => {
    updateSearchParam(searchQuery);
    if (searchQuery) {
      const resultsCount = await fetchResultsCountForAnalytics(searchQuery);
      sendAnalytics(searchQuery, resultsCount);
    }
  };
  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      handleSubmit(event.target.value);
    }
  };
  const handleSearchButtonClick = value => {
    if (!value) {
      updateSearchParam('');
    }
  };

  // Normalize so Clear filters / Clear search (URL drops search_keyword) remounts an empty field.
  const searchValue = initialValue || '';
  return <Container>
      <SearchForm key={searchValue || 'empty-search'} onSearch={handleSearchButtonClick} initialValue={searchValue} enableReinitialize placeholder={I18n.t('publisher.meetings.search.placeholder')} onKeyPress={handleKeyPress} isFullSized
    // Figma Leading controls: TextField + IconButton both small (32px).
    // InlineSearch defaults add spacingTop/Bottom 4 which makes search taller than the filter.
    {...isPhone ? {
      size: 'small',
      spacingTop: 0,
      spacingBottom: 0
    } : {}} />
    </Container>;
};

require("./meetings_page_search_input.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meetings_page_search_input.js");